
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members/account/certification/apply",
      function () {
        return require("private-next-pages/members/account/certification/apply.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members/account/certification/apply"])
      });
    }
  